export default "__VITE_ASSET__tBK3Qcdl__"